import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, State } from './policy.reducer';

export const selectPolicyState = createFeatureSelector<State>(featureKey);

export const getPolicyData = createSelector(selectPolicyState, (state: State) => state.policy);

export const getSelectedAction = createSelector(selectPolicyState, (state: State) => state.selectedAction);
